import { useSessionQuery } from '@/hooks/api/queries/useSessionQuery';

export function useIsIframeSession() {
  const { data: session } = useSessionQuery();

  const isAuthenticated = !!session?.user.id;

  return window.self !== window.top && isAuthenticated;
}
